import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User switched to a different workspace',
  name: 'switched_workspace',
  params: [
    {
      description: 'The ID of the workspace the user switched to',
      name: 'workspace_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
